<template>
	<v-card variant="tonal" color="orange-darken-3" dark>
		<v-tabs v-model="tab" color="primary" grow>
			<v-tab value="curl"><v-icon start>mdi-console</v-icon>cURL</v-tab>
			<v-tab value="js"><v-icon start>mdi-language-javascript</v-icon>JavaScript</v-tab>
			<v-tab value="php"><v-icon start>mdi-language-php</v-icon>PHP</v-tab>
		</v-tabs>

		<v-card-text>
			<v-window v-model="tab">
				<v-window-item value="curl">
					<snippet-block title="Single lookup" language="bash" :code="curlSingle"></snippet-block>
					<snippet-block title="Batch lookup" language="bash" :code="curlBatch"></snippet-block>
				</v-window-item>

				<v-window-item value="js">
					<snippet-block title="Single lookup" language="javascript" :code="jsSingle"></snippet-block>
					<snippet-block title="Batch lookup" language="javascript" :code="jsBatch"></snippet-block>
				</v-window-item>

				<v-window-item value="php">
					<snippet-block title="Single lookup" language="php" :code="phpSingle"></snippet-block>
					<snippet-block title="Batch lookup" language="php" :code="phpBatch"></snippet-block>
				</v-window-item>
			</v-window>
		</v-card-text>
	</v-card>
</template>

<script setup>
	import { computed, ref } from 'vue'
	import hljs from 'highlight.js/lib/core'
	import bash from 'highlight.js/lib/languages/bash'
	import javascript from 'highlight.js/lib/languages/javascript'
	import php from 'highlight.js/lib/languages/php'
	import 'highlight.js/styles/github-dark.css'
	import SnippetBlock from '@/Components/Home/SnippetBlock.vue'

	hljs.registerLanguage('bash', bash)
	hljs.registerLanguage('javascript', javascript)
	hljs.registerLanguage('php', php)

	const props = defineProps({
		batchMax: {
			type: Number,
			default: 100,
		},
	})

	const tab = ref('curl')

	const origin = computed(() => (typeof window !== 'undefined' ? window.location.origin : ''))

	const curlSingle = computed(() => `curl -X POST ${origin.value}/api/v1/lookup \\
  -H "Authorization: Bearer YOUR_API_TOKEN" \\
  -H "Content-Type: application/json" \\
  -d '{"hash": "3f786850e387550fdab836ed7e6dc881de23001b"}'`)

	const curlBatch = computed(() => `curl -X POST ${origin.value}/api/v1/lookup/batch \\
  -H "Authorization: Bearer YOUR_API_TOKEN" \\
  -H "Content-Type: application/json" \\
  -d '{"hashes": ["3f786850e387550fdab836ed7e6dc881de23001b", "..."]}'`)

	const jsSingle = computed(() => `const response = await fetch('${origin.value}/api/v1/lookup', {
  method: 'POST',
  headers: {
    Authorization: 'Bearer YOUR_API_TOKEN',
    'Content-Type': 'application/json',
  },
  body: JSON.stringify({ hash: '3f786850e387550fdab836ed7e6dc881de23001b' }),
})

const { data } = await response.json()
console.log(data.phone_number)`)

	const jsBatch = computed(() => `const response = await fetch('${origin.value}/api/v1/lookup/batch', {
  method: 'POST',
  headers: {
    Authorization: 'Bearer YOUR_API_TOKEN',
    'Content-Type': 'application/json',
  },
  body: JSON.stringify({ hashes: ['3f786850e387550fdab836ed7e6dc881de23001b', '...'] }),
})

const { data } = await response.json()
data.forEach(({ hash, phone_number }) => console.log(hash, phone_number))`)

	const phpSingle = computed(() => `$response = Http::withToken('YOUR_API_TOKEN')
    ->post('${origin.value}/api/v1/lookup', [
        'hash' => '3f786850e387550fdab836ed7e6dc881de23001b',
    ]);

$phoneNumber = $response->json('data.phone_number');`)

	const phpBatch = computed(() => `$response = Http::withToken('YOUR_API_TOKEN')
    ->post('${origin.value}/api/v1/lookup/batch', [
        'hashes' => ['3f786850e387550fdab836ed7e6dc881de23001b', '...'], // max ${props.batchMax} per request
    ]);

$results = $response->json('data');`)

</script>
